// Number of financial days in 1 year
export const FINANCIAL_DAYS_IN_YEAR = 252;

export const DAYS_IN_YEAR = 365;

export const PUBLIC_CUSTOM_INDICATORS = ["alquant1"];

export const DEFAULT_BENCHMARK = {
  id: "GSPC.INDX",
  ticker: "GSPC.INDX",
  name: "S&P 500",
  currency: "USD",
  start_date: "1927-12-30",
  exchange: "predefined",
};

export const SERVER_ERROR_MESSAGE =
  "An error occured in our server. A report has been sent to our team and we will fix it as soon as possible. Don't hesitate to contact us if the issue persists.";

export const DEFAULT_UNDERLYING_ALLOCATION = 100;
